import { useEffect, useState, VFC } from 'react';
import routes from '@/config/routes';
import { UserCollector } from '@/apis/aniftyBackend/users/interface';
import styles from './CollectorList.module.scss';
import { useTranslation } from 'next-i18next';
import fetchUserByID from '@/apis/aniftyBackend/users/fetchUserByID';
import getDisplayName from '@/utils/getDisplayName';
import { convertImgixURL } from '@/utils/imgixUtils';

type Props = {
  collector: UserCollector;
};

const UserTab: VFC<Props> = ({ collector }) => {
  const { i18n } = useTranslation();
  const { ProfilePicUrl, TwitterID, UserName, UserID } = collector;
  const backgroundImg =
    ProfilePicUrl || '/images/user-profile-page/default-profile-picture.png';
  const userLink = UserName
    ? routes.creatorDetail(UserName)
    : routes.myPage(UserID);
  const [displayName, setDisplayName] = useState('');

  const getUserDisplayName = async () => {
    const user = await fetchUserByID(collector.UserID);
    const displayName = await getDisplayName(user, i18n.language);
    setDisplayName(displayName);
  };

  useEffect(() => {
    getUserDisplayName();
  }, []);

  return (
    <a href={userLink} className={styles.userTab}>
      <div
        className={styles.circle}
        style={{
          backgroundImage: `url(${convertImgixURL(backgroundImg, { auto: 'compress' })})`
        }}
      ></div>
      <div className={styles.userTabTxt}>
        <span>{displayName}</span>
        {TwitterID && <span>@{TwitterID}</span>}
      </div>
    </a>
  );
};

export default UserTab;
